module.exports = __webpack_public_path__ + "static/media/favicon.e0e7bcdb.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/favicon.ico
// module id = 738
// module chunks = 0